import React from "react";

const MobileTopBar = ({ title, subtitle, onOpenNav }) => (
  <header className="md:hidden fixed top-0 left-0 right-0 z-30 h-14 border-b border-theme-border bg-theme-main flex items-center gap-3 px-4">
    <button
      type="button"
      aria-label="Open menu"
      className="h-10 w-10 rounded border border-theme-border flex items-center justify-center text-theme-muted hover:border-theme-border-bright hover:text-theme-text transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-accent shrink-0"
      onClick={onOpenNav}
    >
      <span className="material-symbols-outlined text-[22px]">menu</span>
    </button>
    <div className="min-w-0 flex-1">
      <h1 className="font-display font-bold italic text-lg leading-tight text-theme-on-background truncate">
        {title}
      </h1>
      {subtitle ? (
        <p className="font-mono text-[10px] uppercase tracking-[0.08em] text-theme-dim truncate">{subtitle}</p>
      ) : null}
    </div>
  </header>
);

export default MobileTopBar;
